// The ↺ beside a value that has a default: lit while the value is set ("Reset to default (5)"),
// dimmed and disabled while the default applies ("Already default (5)"). Clicking it removes the
// value, so the default applies again. `attached` joins it to the right edge of a number input.
interface ResetToDefaultButtonProps {
    isSet: boolean;
    defaultLabel: string;
    attached?: boolean;
    onReset(): void;
}

const ATTACHED_STYLE = {
    backgroundColor: 'transparent', border: 'solid 1px var(--overlay-color)',
    borderTopLeftRadius: 0, borderBottomLeftRadius: 0, padding: '0 12px', flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
};

function ResetToDefaultButton(props: ResetToDefaultButtonProps) {
    const title = props.isSet ? `Reset to default (${props.defaultLabel})` : `Already default (${props.defaultLabel})`;
    return (
        <button disabled={!props.isSet} title={title}
                style={props.attached ? ATTACHED_STYLE : {opacity: props.isSet ? 1 : 0.4}}
                onClick={props.onReset}>
            <span className={'fa-solid fa-rotate-left'} style={props.attached ? {opacity: props.isSet ? 1 : 0.4} : undefined}/>
        </button>
    );
}

export default ResetToDefaultButton;
